
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.835 7.5C3.155 3.362 5.851 0 10 0c4.15 0 6.845 3.362 7.165 7.5H15.72c-.343-3.296-2.64-5.363-5.72-5.357C6.92 2.137 4.623 4.204 4.28 7.5H2.836zm-1.168 3.134v3.732c0 .81.656 1.467 1.468 1.467H5V9.167H3.135c-.812 0-1.468.657-1.468 1.467zm15.199-1.467H15v6.666h1.866c.811 0 1.467-.656 1.467-1.466v-3.733c0-.81-.656-1.467-1.467-1.467zM7.5 19.19c0 .447.363.809.81.809h2.523v-1.667H8.31c-.447 0-.81.411-.81.858zm8.293-2.524c-.461 1.475-1.824 2.091-4.126 2.091v.851c2.677 0 4.462-.848 5-2.942h-.874z","fill":"#CFC4BE"}})])
          )
        }
      }
    